import { render, staticRenderFns } from "./ListSessions.vue?vue&type=template&id=4ba17f3e&scoped=true&"
import script from "./ListSessions.vue?vue&type=script&lang=js&"
export * from "./ListSessions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba17f3e",
  null
  
)

export default component.exports